<template>
  <div class="taskDelegation" v-loading="dialogLoading">
    <!-- 导航栏部分 -->
    <div class="el-menu-demo">
      <NavMenu />
    </div>
    <div class="taskDelegation-data">
      <div class="btns">
        <div class="search">
          <el-input
            size="small"
            placeholder="请输入流程名称"
            suffix-icon="el-icon-search"
            v-model.trim="queryParams.params.keyWord"
            @change="getEntrustment()"
          ></el-input>
          <UserSelect
            v-auth="{ tranId: 10001741, btnId: 2 }"
            class="userSelect"
            ref="UserSelect"
            :valueInput.sync="clientAccount"
            :placeholder.sync="placeholder"
            @updateData="updateData"
          />
        </div>
        <div>
          <el-button size="small" type="primary" @click="getTaskName()">
            设置委托
          </el-button>
          <el-button
            size="small"
            type="warning"
            :disabled="batchCancelId.length > 0 ? false : true"
            @click="cancelEntrust()"
          >
            批量取消委托
          </el-button>
        </div>
      </div>
      <div class="taskDelegation-table">
        <el-table
          ref="multipleTable"
          :data="entrustList"
          border
          height="100%"
          :default-sort="{ prop: 'date', order: 'descending' }"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" fixed></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
            :selectable="(row) => !row.cancellTime"
            fixed
          ></el-table-column>
          <el-table-column
            v-for="item in tableColumns"
            :key="item.prop"
            v-bind="item"
            align="center"
          />
          <el-table-column label="操作" min-width="120" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="!scope.row.cancellTime" size="mini" type="text" @click="getTaskName(scope.row)">
                修改
              </el-button>
              <el-button v-if="!scope.row.cancellTime" size="mini" type="text" @click="cancelEntrust(scope.row)">
                取消委托
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            background
            size="mini"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          @current-change="currentChange"
          @size-change="sizeChange"
          :current-page="Pagination.currentPage"
          :page-sizes="[15, 30, 40, 50, 100]"
          :page-size="Pagination.pagesize"
          align="center"
          class="pagination"
        ></el-pagination>
      </div>
    </div>
    <DrawerForm
      ref="DrawerForm"
      :dialogTitle="'设置委托'"
      :dialogWidth="'500px'"
      :formLabelWidth="formLabelWidth"
      :dialogFields="dialogFields"
      @submit="addEntrustment"
    />
  </div>
</template>

<script>
import bpmApi from '@/api/activityBPM/index'
import UserSelect from '../../common/UserSelect'
import { tableColumns, dialogFields } from './config'
import DrawerForm from '../common/DrawerForm'
import NavMenu from '../../common/NavMenu'
import dayjs from 'dayjs'
export default {
  name: 'taskDelegation',
  components: {
    NavMenu,
    DrawerForm,
    UserSelect
  },
  data() {
    return {
      taskList: [],
      cancelId: 0,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      entrustList: [],
      loading: false,
      dialogLoading: false,
      totalCount: 0, //总条数
      Pagination: {
        currentPage: 1,
        pagesize: 15
      },
      tableColumns,
      dialogFields,
      queryParams: {
        page: 1,
        size: 15,
        params: {
          dataType: 0,
          keyWord: ''
        }
      },
      placeholder: '请输入委托人工号或姓名',
      insertData: {
        agent: '',
        agentAccount: '',
        startTime: '',
        endTime: '',
        procKeyAndDefNameList: []
      },
      batchCancelId: [],
      editType: 'insert',
      clientAccount: '' // 委托人
    }
  },
  mounted() {
    this.getEntrustment(this.Pagination)
  },
  methods: {
    getEntrustment(Pagination) {
      // 获取任务委托列表
      this.loading = true
      let params = JSON.parse(JSON.stringify(this.queryParams))
      if (Pagination) {
        params.page = Pagination.currentPage
        params.size = Pagination.pagesize
      } else {
        this.Pagination.pagesize = params.size
      }
      bpmApi.entrustment.pageQueryAll(params).then((res) => {
        if (res.code != '0000') {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
        this.entrustList = res.data.content || []
        this.totalCount = res.data.totalElements
        this.loading = false
      })
    },
    addEntrustment(form) {
      // 设置委托
      if (this.clientAccount) {
        form.clientAccount = this.clientAccount.split('-')[0]
        form.client = this.clientAccount.split('-')[1]
      } else {
        form.clientAccount = this.$store.state.user.psnCode
        form.client = this.$store.state.user.psnName
      }
      let params = JSON.parse(JSON.stringify(form))
      params.dataType = 0
      params.startTime = form.selectedTime[0]
      params.endTime = form.selectedTime[1]
      if (!form.id && new Date().getTime() > new Date(params.startTime).getTime()) {
        this.$message.warning('开始时间不能小于当前时间')
        return
      }
      if (new Date(params.endTime).getTime() <= new Date(params.startTime).getTime()) {
        this.$message.warning('结束时间必须大于开始时间')
        return
      }
      params.procKeyAndDefNameList = []
      if (form.checkboxValue === true) {
        this.taskList.forEach((item) => {
          // 处理任务类型
          params.procKeyAndDefNameList.push({
            procKey: item.key,
            procDefName: item.procDefName
          })
        })
      } else {
        form.procKeyAndDefNameList.forEach((item) => {
          // 处理任务类型
          let value = item.split('-')
          params.procKeyAndDefNameList.push({
            procKey: value[0],
            procDefName: value[1]
          })
        })
      }
      this.$refs.DrawerForm.dialogFormVisible = false
      params.agentAccount = params.agent.split('-')[0]
      params.agent = params.agent.split('-')[1]
      this.dialogLoading = true
      bpmApi.entrustment[this.editType](params).then((res) => {
        this.dialogLoading = false
        this.$refs.DrawerForm.handleClose()
        if (res.code != '0000') {
          this.$message({
            type: 'error',
            message: res.msg
          })
        } else {
          this.$message.success(res.data || '设置委托成功')
          this.getEntrustment()
        }
      })
    },
    getTaskName(row) {
      this.$refs.DrawerForm.dialogFormVisible = true
      this.$nextTick(() => {
        // 处理设置委托数据
        this.editType = 'insert'
        this.$set(this.$refs.DrawerForm.form, 'checkboxValue', true)
        if (row) {
          this.$set(this.$refs.DrawerForm.form, 'selectedTime', [row.startTime, row.endTime])
          this.$set(this.$refs.DrawerForm.form, 'id', row.id)
          this.$set(this.$refs.DrawerForm.form, 'checkboxValue', false)
          this.$set(this.$refs.DrawerForm.form, 'agent', row.userId + '-' + row.agent)
          this.$set(
            this.$refs.DrawerForm.$refs.UserSelect[0],
            'value',
            row.userId + '-' + row.agent
          )
          this.$set(this.$refs.DrawerForm.form, 'startTime', row.startTime)
          this.$set(this.$refs.DrawerForm.form, 'endTime', row.endTime)
          this.$set(this.$refs.DrawerForm.form, 'procKeyAndDefNameList', [
            row.procKey + '-' + row.procDefName
          ])
          this.editType = 'revise'
        } else {
          this.dialogFields.forEach(item => {
            if (item.prop === 'selectedTime') {
              item.defaultTime = [dayjs().add(1, 'minute').format('HH:mm:ss'), dayjs().add(1, 'minute').format('HH:mm:ss')]
            }
          })
        }
      })
      this.dialogLoading = true
      if (!this.taskList.length) {
        // 获取任务名称列表
        let params = JSON.parse(JSON.stringify(this.queryParams))
        params.dataType = 0
        bpmApi.procDef.listProcessDef(params).then((res) => {
          this.dialogLoading = false
          if (res.code != '0000') {
            this.$message({
              type: 'error',
              message: res.msg
            })
            return
          }
          this.taskList = res.data || []
          this.dialogFields.forEach((item) => {
            if (item.prop === 'procKeyAndDefNameList') {
              item.fieldOption.options = this.taskList
            }
          })
        })
      } else {
        this.dialogLoading = false
      }
    },
    // 表格分页设置
    currentChange(currentPage) {
      this.Pagination.currentPage = currentPage
      this.getEntrustment(this.Pagination)
    },
    sizeChange(pagesize) {
      this.Pagination.pagesize = pagesize
      this.getEntrustment(this.Pagination)
    },
    cancelEntrust(row) {
      // 取消委托
      if (row) {
        this.batchCancelId = []
        this.batchCancelId.push(row.id)
      }
      // 二次确认删除
      this.$confirm('确定要取消吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.dialogLoading = true
          bpmApi.entrustment
            .cancellBatch({ entrustmentIdList: this.batchCancelId, dataType: 0 })
            .then((res) => {
              this.dialogLoading = false
              if (res.code != '0000') {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              } else {
                this.$message.success('取消成功')
              }
              this.getEntrustment()
            })
        })
        .catch(() => {})
    },
    handleSelectionChange(val) {
      // 批量取消委托
      this.batchCancelId = []
      val.forEach((item) => {
        this.batchCancelId.push(item.id)
      })
    },
    updateData() {
      // 管理员查询
      if (this.clientAccount) {
        this.queryParams.params.clientAccount = this.clientAccount.split('-')[0]
      } else {
        this.queryParams.params.clientAccount = ''
      }
      this.getEntrustment(this.Pagination)
    }
  }
}
</script>
<style lang="scss" scoped>
.taskDelegation {
  .taskDelegation-data {
    margin: 10px 20px;
    .btns {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .search {
        display: flex;
        .userSelect {
          width: 320px;
          margin-left: 10px;
        }
      }
    }
    .taskDelegation-table {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 150px);
      .pagination{
        margin-top: 20px;
      }
    }
  }
}

/deep/ .el-form-item__label {
  font-size: 16px;
}
// 表格样式
/deep/ tbody {
  cursor: pointer;
}
// 表格样式
/deep/ .el-table {
  thead th {
    color: #525252;
    background-color: #f2f6fc;
  }
  .el-table__cell {
    padding: 3px 0;
  }
}
/deep/ .el-autocomplete {
  width: 100%;
}
</style>
